<template>
	<div class="about-env">
		<div class="page-container">
			<PageTitle ch="關於「利澤」" en="About “Lìzé”"></PageTitle>
			<b-row>
				<b-col md="6" sm="12" order-md="1" order-sm="2" class="left">
					<p class="content-ch">利澤舊名「利澤簡」，來自平埔族噶瑪蘭人利澤簡（Hedecanan）社，意指「休息之地」。早期港口商船往來頻繁，街道商家林立，為通往羅東、三星、蘇澳之要衝，是蘭陽溪以南最繁華的貨物集散地。隨著港口淤塞、火車開通，交通線西移，加上冬山河截彎取直工程，街道也隨之凋零。現今利澤老街上仍可找到風姿綽約的古蹟，為往日風華做見證。</p>
					<p class="content-en">The old name of Town Lize is called Lizejian which was from aboriginal language (Pingpu Tribe, Kavalan people), meaning “a place for taking a rest.” In the old times, it was the busiest intersection between Luodong, Sanxing, and Suao for trading goods in the south of Lanyang River, the main river in Yilan. Its nearby port was busy with commercial ships, and its streets were full of shops. Because more and more dirt blocked the port, the Dongshan River’s route was straightened, and the new railways were opened, the streets of Lize are not busy anymore. The elegant heritage that can be found on Lize Old Street is a proof of the town’s glorious history. </p>
				</b-col>
				<b-col md="6" sm="12" order-md="2" order-sm="1" class="right p1"></b-col>
			</b-row>
			<PageTitle class="surrounding" ch="附近景點" en="Surroundings"></PageTitle>
			<b-row>
				<b-col md="6" sm="12" class="right p2"></b-col>
				<b-col class="left">
					<div class="title-ch">利生醫院</div>
					<div class="title-en">Lisheng Hospital</div>
					<div class="content-ch">建於1920年的著名地標「利生醫院」，是老街最早的西式建築，原為利澤簡信用合作社，之後曾作為輕便車站、五結鄉農會。利生醫院起源於林木溪先生，林家三代皆在此行醫，有「三代華陀」之稱。</div>
					<div class="content-en">Lisheng Hospital was built in 1920; it has become a landmark here. It is the oldest western style building on the main street; it used to be Lizejian Credit Cooperatives (a bank,) and it was also once a temporary station, and then Farmers’ Association of Wu-jie Township. The owners of the hospital are doctors for three generations.</div>
				</b-col>

			</b-row>
			<b-row>
				<b-col md="6" sm="12" order-md="1" order-sm="2" class="left">
					<div class="title-ch">利澤戲院</div>
					<div class="title-en">Lize Theater</div>
					<div class="content-ch">位於利生醫院對面的利澤戲院於1964年開幕，除了放映電影，還有黑貓歌舞團等現場演出、歌仔戲巨星楊麗花曾經在此登台，一票難求。然而羅東的興盛加速利澤簡的沒落，電視機普及也為戲院的營運畫上句點。</div>
					<div class="content-en">Lize Theater was located opposite to Lisheng Hospital. It opened in 1964. In addition to movies screening, there were also Taiwanese opera superstar and entertainment show troupes performing here, which was quite a buzz and sensation at that time. But with the new town Luodong emerging and televisions getting prevailing, the theater operates no more. </div>
				</b-col>
				<b-col md="6" sm="12" order-md="2" order-sm="1" class="right p3"></b-col>
			</b-row>
			<b-row>
				<b-col md="6" sm="12" class="right p4"></b-col>
				<b-col class="left" md="6" sm="12">
					<div class="title-ch">永安宮</div>
					<div class="title-en"> Yongan Temple</div>
					<div class="content-ch">興建於清道光六年（西元1826年），為蘭陽溪以南的最古早的媽祖廟。一年一度的民俗盛事「走尪」，是從農曆年初神明遶境八大庄頭後，於元宵節回到永安宫前抬轎過金火競賽的一種儀式，具有避邪袪災的作用。</div>
					<div class="content-en">Yongan Temple was built in 1826. It was the oldest temple worshipping Goddess Mazhu in the south of Lanyang River. The very important annual folk event “Zou-ang”, which literally means “Walk the Figure,” at every beginning of the year is actually a important ritual held here. After people carrying the sedan chair with figure of Mazhu sitting inside going around the neighborhood and back to the temple, the procession then has to go over across fire. It has the function of casting away the evil and dispelling disasters.</div>
				</b-col>

			</b-row>
			<b-row>
				<b-col md="6" sm="12" order-md="1" order-sm="2" class="left">
					<div class="title-ch">利澤簡教會</div>
					<div class="title-en">Lizejian Church</div>
					<div class="content-ch">清同治12年（西元1873年）馬偕博士進入蘭陽平原，起初因基督徒不能燒香拜拜遭受漢人排斥，信仰者多為平埔族噶瑪蘭人。當時利澤簡教會設於冬山河舊道旁的「流流社」，二十世紀初漢人信徒漸多，才在老街上建立新的教堂。</div>
					<div class="content-en">In 1873, Priest and Dr. George Mackay came to Taiwan and entered Lanyang Plain. His early evangelizing was not welcome by Han people because Christian did not allow Han people to pray using incense. At that time, most followers were Kavalan people, Pingpu Tribe aborigines. Lizejian Church was first established beside the old Dongshan River route; the new church had not been built on the main street of Lize until the beginning of 20th century when Han followers increased.</div>
				</b-col>
				<b-col md="6" sm="12" order-md="2" order-sm="1" class="right p5"></b-col>
			</b-row>
			<b-row>
				<b-col md="6" class="right p6"></b-col>
				<b-col class="left">
					<div class="title-ch">廣惠宮</div>
					<div class="title-en">Guanghuei Temple</div>
					<div class="content-ch">廟內主祀廣惠尊王謝安，創建於清同治10年（西元1871）年，1951年重建為現今樣貌，俗稱王公廟。王公顯靈傳奇故事代代相傳，並保存有「求虎皮保平安」、「爆尪（弄新娘）」等深具文化特色之地方民俗活動。</div>
					<div class="content-en">This temple worshipped General An HSIEH. It was established in 1871 and was re-built in 1951 as what it is like now. People call it Lord’s Temple. There have been many legendary stories of the lord showing presence and promising people’s wishes. The temple also preserves a few folk activities with local characteristics, such as “wearing tigers’ fur to pray for safety” and “blow up the figure with firecrackers.”</div>
				</b-col>

			</b-row>
			<b-row>
				<b-col class="left" md="6" sm="12" order-md="1" order-sm="2">
					<div class="title-ch">五十二甲溼地</div>
					<div class="title-en">Wu-shi-er-jia Wetland</div>
					<div class="content-ch">早期為冬山河舊河道，地勢低窪，常年積水，保留了近200甲良好的水田環境與溼地生態，天然土堤環境孕育了全台獨有的風箱樹與最大的水茄苳棲地，每年十月至隔年三月吸引大量的候鳥棲息，調查記錄有170種以上的鳥類。</div>
					<div class="content-en">This area used to be the old route of Dongshan River. It is low and therefore was ponded all the year round. It makes nearly 200 hectares of water field and wetland. The natural dirt breeds the unique buttonbushes and the largest Small-leaved Barringtonia habitat in Taiwan. Surveys show that there are more than 170 kinds of migrant birds staying here every October to March. </div>
				</b-col>
				<b-col md="6" sm="12" order-md="2" order-sm="1" class="right p7"></b-col>
			</b-row>
		</div>
	</div>
</template>


<script>
import PageTitle from '@/components/page_title'

export default {

  metaInfo: {
    title: '利澤國際偶戲藝術村'
  },
  name: 'about-env',
  data() {
    return {

    }
  },
  components: {
    PageTitle
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
  @import '../../stylesheet/base.sass'
  @import '../../stylesheet/layout.sass'

  .about-env
    padding: 0
    text-align: justify
    .surrounding
      margin-top: 115px
    .left
      min-height: 425px
      padding: 40px
    .right
      min-height: 425px
      background-size: cover
      background-position: 50% 50%
    .p1
      background-image: url('../../assets/about/envirnment/img_about.png')
    .p2
      background-image: url('../../assets/about/envirnment/img_spot_1.png')
    .p3
      background-image: url('../../assets/about/envirnment/img_spot_2.png')
    .p4
      background-image: url('../../assets/about/envirnment/img_spot_3.png')
    .p5
      background-image: url('../../assets/about/envirnment/img_spot_4.png')
    .p6
      background-image: url('../../assets/about/envirnment/img_spot_5.png')
    .p7
      background-image: url('../../assets/about/envirnment/img_spot_6.png')
    .title-ch
      font-size: $font-size-1
    .title-en
      margin: 5px 0 27px 0
      font-size: $font-size-3
    .content-ch
      font-size: $font-size-3-s
      line-height: 1.5
      letter-spacing: 2px
      margin-bottom: 15px
    .content-en
      font-size: $font-size-4
      line-height: 1.3
      letter-spacing: 1px

</style>



// WEBPACK FOOTER //
// src/pages/about/about_env.vue